/** Название приложения во вкладке браузера (шаблон Helmet и document.title). */
export const APP_NAME = 'Nomad Finance';

/** Полное название компании: экран входа, копирайт. */
export const COMPANY_NAME = 'Nomad Finance Solutions';

export enum Languages {
  ru = 'ru',
  en = 'en',
  kk = 'kk'
}
export const SUPPORTED_LANGUAGES = [Languages.ru, Languages.en, Languages.kk];

/** Коды должностей сотрудников: по ним открываются экраны и действия. */
export enum UserPositions {
  Director = '4',
  Admin = '5',
  Reports = '6',
  LeasingManager = 'leasing_manager',
  LeasingDirector = 'leasing_director',
  Underwriter = '1001',
  MonitoringManager = 'monitoring_manager',
  CarAppraiser = 'car_appraiser'
}

/** Коды отдельных разрешений сотрудника. */
export enum UserActions {
  /** Ручное решение по заявке на лизинг. */
  ManualDecisions = 10
}

/** Подписи языков в переключателе в шапке. */
export const LANG_LABELS: Record<Languages, string> = {
  [Languages.ru]: 'РУС',
  [Languages.en]: 'ENG',
  [Languages.kk]: 'ҚАЗ'
};

/** Названия языков на самих этих языках — не переводятся, узнаются в любой локали. */
export const LANG_NATIVE_NAMES: Record<Languages, string> = {
  [Languages.ru]: 'Русский',
  [Languages.en]: 'English',
  [Languages.kk]: 'Қазақша'
};

/** Маски полей ввода (синтаксис imask): 0 — любая цифра, {7} — фиксированная часть значения. */
export const INPUT_MASKS = {
  /** Телефон Казахстана без кода страны: «+7» показывает PhoneInput префиксом поля. */
  phoneLocal: '(000) 000-00-00',
  /** ИИН — 12 цифр. */
  iin: '000000000000'
};

export const COMMON_DATE_FORMAT = 'DD.MM.YYYY, HH:mm';
/** Дата без времени — для показа и полей DatePicker. */
export const DATE_FORMAT = 'DD.MM.YYYY';
/** Дата в данных и запросах. */
export const API_DATE_FORMAT = 'YYYY-MM-DD';

/** Размеры страницы списков с пагинацией; первый — по умолчанию. */
export const LIST_PAGE_SIZES = [10, 20, 50];

/** Через сколько бездействия сессия завершается автоматически: 15 минут. */
export const IDLE_TIMEOUT_MS = 15 * 60 * 1000;

/** Ключ localStorage со временем последней активности — общий для всех вкладок. */
export const IDLE_ACTIVITY_STORAGE_KEY = 'mfo-main-last-activity';

/** Задержка поиска в списках перед запросом, мс. */
export const LIST_SEARCH_DELAY = 500;

/** Типографские символы для пустых значений и сумм. */
export const SYMBOLS = {
  longDash: '—',
  tenge: '₸'
};
